import React, { useState } from "react";
import logo from "../assets/images/ARCIUM_Final_Brand_LANDSCAPE-removebg-preview.png";
import insta from "../assets/images/svgs/insta.png";
import wp from "../assets/images/svgs/whats-app-whatsapp-whatsapp-icon-svgrepo-com.png";
import arrowdown from "../assets/images/svgs/down-arrow-svgrepo-com.svg";
import useAOS from "./useAos";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [animationClass, setAnimationClass] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // State to handle the mobile "Services" dropdown
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);

  useAOS();

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleButtonClick = () => {
    if (!isMenuOpen) {
      setAnimationClass("animate-spin-once");
    } else {
      setAnimationClass("animate-spin-reverse");
    }
    toggleMenu();
    setTimeout(() => {
      setAnimationClass("");
    }, 1000);
  };

  return (
    <div className="bg-blue-500 flex">
      <nav className="lg:px-12 relative py-4 flex w-full justify-between items-center bg-background">
        {/* Logo */}
        <a className="text-3xl font-bold leading-none" href="/">
          <img
            src={logo}
            alt="Logo"
            className="h-10 transition duration-300 ease-in-out hover:scale-110"
          />
        </a>

        {/* Hamburger (Mobile) */}
        <div className="lg:hidden">
          <button
            className="navbar-burger flex items-center text-blue-600 p-3"
            onClick={handleButtonClick}
          >
            <svg
              className={`block h-4 w-4 fill-current ${animationClass}`}
              viewBox="0 0 20 20"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Mobile menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>

        {/* Desktop Menu */}
        <ul className="hidden lg:flex w-full font-orbitron md:text-sm lg:justify-center lg:items-center lg:space-x-8">
          <li className="hover:scale-125 transition duration-300 ease-in-out">
            <a className="text-gray-400 hover:text-hover" href="/">
            Home
            </a>
          </li>
          <li className="hover:scale-125 transition duration-300 ease-in-out">
            <a className="text-gray-400 hover:text-hover" href="/about-us">
            About us
            </a>
          </li>

          {/* Services Dropdown (Desktop, hover-based) */}
          <li
            className="relative"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <a
              className="group hover:cursor-pointer flex justify-center items-center gap-2 hover:scale-125 transition duration-300 ease-in-out text-gray-400 hover:text-hover"
              href="/services"
            >
              Services
              <img
                src={arrowdown}
                alt="Arrow Down"
                className={`h-3 transform transition duration-300 ease-in-out ${
                  isDropdownOpen ? "rotate-180" : "group-hover:rotate-180"
                }`}
              />
            </a>

            {isDropdownOpen && (
              <ul className="absolute left-0 top-full w-40 bg-background shadow-lg rounded z-50">
                <li className="px-4 py-2 hover:bg-blue-50">
                  <Link to="/services/planning" className="hover:text-hover">
                  Planning
                  </Link>
                </li>
                <li className="px-4 py-2 hover:bg-blue-50">
                  <Link to="/services/interior" className="hover:text-hover">
                  Interior
                  </Link>
                </li>
                <li className="px-4 py-2 hover:bg-blue-50">
                  <Link
                    to="/services/consulting"
                    className="hover:text-hover"
                  >
                    Consulting
                  </Link>
                </li>
                <li className="px-4 py-2 hover:bg-blue-50">
                  <Link
                    to="/services/supervising"
                    className="hover:text-hover"
                  >
                    Supervising
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li className="hover:scale-125 transition duration-300 ease-in-out">
            <a className="text-gray-400 hover:text-hover" href="/projects">
            Projects
            </a>
          </li>
          <li className="hover:scale-125 transition duration-300 ease-in-out">
            <a className="text-gray-400 hover:text-hover" href="/contact">
            Contact
            </a>
          </li>
        </ul>

        {/* Social Icons (Desktop) */}
        <div className="hidden px-4 space-x-10 lg:flex items-center">
        <a href="https://www.instagram.com/arcium_studio/" className="link hover:scale-125 transition duration-300 ease-in-out hover:cursor-pointer" aria-label="X Link">
            <img src={insta} className='w-8' alt="" />
        </a>
        </div>
        <div className="hidden px-4 space-x-10 lg:flex items-center">
        <a href="https://wa.me/37745541556" className="link hover:scale-125 transition duration-300 ease-in-out hover:cursor-pointer" aria-label="X Link">
            <img src={wp} className='w-9' alt="" />
        </a>
        </div>
      </nav>

      {/* Sidebar (Mobile) */}
      <div className="navbar-menu relative z-50">
        <div
          className={`navbar-backdrop fixed inset-0 bg-color1 transition-opacity duration-300 ${
            isMenuOpen ? "opacity-25 pointer-events-auto" : "opacity-0 pointer-events-none"
          }`}
          onClick={toggleMenu}
        />
        <nav
          className={`lg:hidden fixed top-0 left-0 bottom-0 flex flex-col w-full py-6 px-6 bg-background overflow-y-auto transform transition-transform duration-300 ease-in-out ${
            isMenuOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex items-center mb-8">
            <a className="mr-auto text-3xl font-bold leading-none" href="/">
              <img src={logo} alt="Logo" className="h-10" />
            </a>
            <button className="navbar-close" onClick={toggleMenu}>
              <svg
                className="h-6 w-6 text-gray-400"
                viewBox="0 0 24 24"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 18L18 6M6 6l12 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="white"
                />
              </svg>
            </button>
          </div>
          <ul>
            <li>
              <a
                className="block p-4 text-xl font-orbitron text-gray-400 hover:bg-blue-50 hover:text-blue-600"
                href="/"
              >
                Startseite
              </a>
            </li>
            <li>
              <a
                className="block p-4 text-xl font-orbitron text-gray-400 hover:bg-blue-50 hover:text-blue-600"
                href="/about-us"
              >
                About Us
              </a>
            </li>
            {/* Mobile Services Dropdown */}
            <li>
              <button
                onClick={() => setIsMobileServicesOpen((prev) => !prev)}
                className="block w-full text-left p-4 text-xl font-orbitron text-gray-400 hover:bg-blue-50 hover:text-blue-600 focus:outline-none"
              >
                <a href="/services">services</a>
                <img
                  src={arrowdown}
                  alt="Arrow Down"
                  className={`inline-block ml-6  h-5 transform transition duration-300 ease-in-out ${
                    isMobileServicesOpen ? "rotate-180" : "rotate-0"
                  }`}
                />
              </button>
              {isMobileServicesOpen && (
                <ul className="pl-6">
                  <li>
                    <a
                      className="block py-2 text-lg font-orbitron text-gray-400 hover:text-blue-600 hover:bg-blue-50"
                      href="/services/planning"
                    >
                      Planning
                    </a>
                  </li>
                  <li>
                    <a
                      className="block py-2 text-lg font-orbitron text-gray-400 hover:text-blue-600 hover:bg-blue-50"
                      href="/services/interior"
                    >
                      Interior
                    </a>
                  </li>
                  <li>
                    <a
                      className="block py-2 text-lg font-orbitron text-gray-400 hover:text-blue-600 hover:bg-blue-50"
                      href="/services/consulting"
                    >
                      Consulting
                    </a>
                  </li>
                  <li>
                    <a
                      className="block py-2 text-lg font-orbitron text-gray-400 hover:text-blue-600 hover:bg-blue-50"
                      href="/services/supervising"
                    >
                      Supervising
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a
                className="block p-4 text-xl font-orbitron text-gray-400 hover:bg-blue-50 hover:text-blue-600"
                href="/projects"
              >
                Projects
              </a>
            </li>
            <li>
              <a
                className="block p-4 text-xl font-orbitron text-gray-400 hover:bg-blue-50 hover:text-blue-600"
                href="/contact"
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
